/**
 * Web Style Import
 *
 */

import './style/dnb-visually-hidden.scss'
